import React from 'react';

const UsaSpecializedSection = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 gap-4 grid">
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Let&apos;s Transform Your Vision into Reality—Now in the USA!
                        </h2>
                        <p className="text-secondary mb-0">
                            Moweb Technologies is coming to the USA, and we&apos;re ready to meet face-to-face with visionary
                            businesses like yours. This is your exclusive opportunity to explore how our custom software and
                            mobile app solutions can revolutionize your operations, enhance efficiency, and future-proof your
                            business for years to come.
                        </p>
                        <p className="text-secondary" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            From enterprise software development to mobile app innovation, our team of experts is at the forefront
                            of delivering high-quality, agile solutions. We&apos;ve worked across a multitude of industries,
                            successfully implementing cutting-edge technologies to optimize operations and scale businesses. Now,
                            we&apos;re here to help you do the same.
                        </p>
                    </div>
                </div>
                <div className="row grid md:grid-cols-12 lg:grid-cols-12 place-items-center">
                    <div className="col-span-full w-11/12">
                        <div className="services-listing" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            <div className="row grid md:grid-cols-12 lg:grid-cols-12 overflow-hidden">
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="200"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Strategy</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Consultancy</li>
                                            <li>Ideation</li>
                                            <li>Idea Validation</li>
                                            <li>Product Engineering</li>
                                            <li>Policies</li>
                                            <li>Stakeholders</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="300"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Design</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Concept Development</li>
                                            <li>Prototyping</li>
                                            <li>Usability</li>
                                            <li>User Validation</li>
                                            <li>User Interface (UI) Design</li>
                                            <li>User Experience (UX) Design</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="400"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Development</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Native iOS and Android App</li>
                                            <li>Cross Platform & Hybrid App</li>
                                            <li>Web App & E-commerce</li>
                                            <li>Information System</li>
                                            <li>Backend & CMS</li>
                                            <li>Rest API & Middleware</li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className="md:col-span-3 lg:col-span-3"
                                    data-aos="fade-left"
                                    data-aos-duration="700"
                                    data-aos-delay="500"
                                >
                                    <div className="service-card">
                                        <div className="service-title star-stat">
                                            <p className="inverse">Support</p>
                                        </div>
                                        <ul className="service-list grid gap-3">
                                            <li>Proactive Monitoring</li>
                                            <li>Server Maintenance</li>
                                            <li>Database Backup</li>
                                            <li>Test Strategies</li>
                                            <li>Evaluation</li>
                                            <li>Dedicated Support</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UsaSpecializedSection;
